import React from "react";
import { bool, func, string, number, node } from "prop-types";

import Radio from "../shared/Radio";
import Typography from "../shared/Typography";
import MoreInformation from "../shared/MoreInformation";

import gtm from "@gtm/core";
import { displayMoreInfoEvent } from "@gtm/events/shared";
import { twMerge } from "tailwind-merge";

const DeliveryOption = ({
  selected,
  onChange,
  label,
  description,
  moreInformation,
  formattedPrice,
  identifier,
  hideInput = false,
}) => {
  const gtmEvent = eventAction =>
    gtm.fire(
      displayMoreInfoEvent({
        action: `${label}::${eventAction}`,
        label,
      })
    );

  return (
    <div
      className={twMerge(
        "rounded-md px-2 py-4 border transition duration-300",
        selected
          ? "bg-white border-greyLight"
          : "border-greyLight/50 hover:bg-white/80"
      )}
      data-id={`delivery-option-container-${identifier}`}
    >
      <div className="flex justify-between">
        <Radio
          checked={selected}
          className="font-bold"
          data-id={`delivery-option-${identifier}-${
            selected ? "checked" : "unchecked"
          }`}
          hideInput={hideInput}
          label={label}
          onChange={onChange}
        />
        <Typography
          className="font-semibold"
          data-id={`delivery-price-${identifier}`}
        >
          {formattedPrice}
        </Typography>
      </div>
      <div className={hideInput ? "ml-4" : "ml-11"}>
        <Typography className="text-sm">{description}</Typography>
        {!!moreInformation && (
          <MoreInformation
            dataId={`more-information-${label}-panel`}
            expansionMode="above"
            gtmEvent={gtmEvent}
            label={label}
          >
            <Typography
              className="text-sm"
              data-id={`more-information-${label}-text`}
              label={label}
            >
              {moreInformation}
            </Typography>
          </MoreInformation>
        )}
      </div>
    </div>
  );
};

DeliveryOption.propTypes = {
  selected: bool.isRequired,
  onChange: func.isRequired,
  label: string.isRequired,
  description: string.isRequired,
  formattedPrice: node.isRequired,
  moreInformation: string,
  identifier: number,
  hideInput: bool,
};

export default DeliveryOption;
